<template>
  <v-row>
    <v-col class="px-0">
      <v-btn
        :disabled="
          !props.isEditable ||
          expandedRowsDrawings?.length > 0 ||
          inventoryStore.isAddingOrEditingDrawingTable ||
          inventoryStore.isAddingOrEditingEDocs
        "
        id="btn_addDrawing"
        variant="outlined"
        class="my-2 ml-3"
        @click="addDrawing()"
        >{{ addButtonText }}</v-btn
      >
    </v-col>
  </v-row>
  <v-row class="mb-8">
    <v-col cols="12">
      <v-data-table
        class="noScrollTable compactTable"
        :items="localDrawingsArray"
        :headers="drawingsHeaders"
        v-model:expanded="expandedRowsDrawings"
        hide-default-footer
        :items-per-page="-1"
        show-expand
        return-object
      >
        <template v-slot:[`header.data-table-expand`]="{ column }">
          {{ column.title }}
        </template>
        <template v-slot:[`header.drawingType`]="{ column }">
          <DataTableHeader :column="column" :lines="1" />
        </template>
        <template v-slot:[`header.drawingNum`]="{ column }">
          <DataTableHeader :column="column" :lines="1" />
        </template>
        <template v-slot:[`header.drawingDesc`]="{ column }">
          <DataTableHeader :column="column" :lines="1" />
        </template>
        <template v-slot:[`header.Action`]="{ column }">
          <DataTableHeader :column="column" :lines="1" />
        </template>
        <template v-slot:item="{ item }">
          <tr :class="rowClassDrawing(item)">
            <td class="text-center">
              <template v-if="!anyEditableDrawings">
                <button v-if="!isExpandedDrawing(item)" @click="toggleDrawingRow(item)">
                  <v-icon :id="`icon_Chevron_Right_${item.drawingKey}`" icon="fa-solid fa-chevron-right"></v-icon>
                </button>

                <button v-if="isExpandedDrawing(item)" @click="toggleDrawingRow(item)">
                  <v-icon :id="`icon_Chevron_Down_${item.drawingKey}`" icon="fa-solid fa-chevron-down"></v-icon>
                </button>
              </template>
            </td>
            <td class="alignCenter">
              {{
                item.drawingType
                  ? configStore.getReferenceValue(REFERENCE_TABLE.DRAWING_TYPE, item.drawingType, true)
                  : ""
              }}
            </td>
            <td class="alignCenter">
              {{ item?.drawingNum }}
            </td>
            <td class="alignCenter">
              {{ item?.drawingDesc }}
            </td>
            <td class="alignCenter">
              <div
                style="white-space: nowrap"
                v-if="isExpandedDrawing(item) && anyEditableDrawings && props.isEditable"
              >
                <IconTooltip
                  id="icon_add"
                  icon="fa-solid fa-check"
                  :tooltip="item?.isAdd ? 'Add' : 'Update'"
                  @click="saveDrawing()"
                />
                <IconTooltip id="icon_close" icon="fa-solid fa-xmark" tooltip="Close" @click="closeDrawing(item)" />
              </div>
              <div
                style="white-space: nowrap"
                v-else-if="
                  !inventoryStore.isAddingOrEditingDrawingTable &&
                  !inventoryStore.isAddingOrEditingEDocs &&
                  props.isEditable &&
                  (expandedRowsDrawings?.length == 0 || !anyEditableDrawings)
                "
              >
                <IconTooltip id="icon_edit" icon="fa-solid fa-pencil" tooltip="Edit" @click="editDrawing(item)" />
                <IconTooltip id="icon_delete" icon="fa-solid fa-trash" tooltip="Delete" @click="deleteDrawing(item)" />
              </div>
            </td>
          </tr>
        </template>
        <template v-slot:expanded-row="{ item }">
          <td :colspan="drawingsHeaders.length">
            <v-form ref="drawingsForm" v-model="validDrawings" class="mt-2" @change="changesDetectedDrawing = true">
              <v-row>
                <v-col xl="6" lg="6" md="12" sm="12" cols="12" class="px-0 pt-3">
                  <LabelSelect
                    labelXl="4"
                    labelLg="6"
                    labelMd="3"
                    labelSm="4"
                    selectXl="8"
                    selectLg="6"
                    selectMd="4"
                    selectSm="5"
                    :id="`drawingType_${item.drawingKey}`"
                    label="ED.09 Drawing Type"
                    isRequired
                    :options="drawingTypes"
                    :isEditable="props.isEditable && !item.readOnly"
                    v-model="item.drawingType"
                    @update:modelValue="
                      {
                        changesDetectedDrawing = true;
                      }
                    "
                  />
                </v-col>
                <v-col
                  xl="6"
                  lg="6"
                  md="12"
                  sm="12"
                  cols="12"
                  :class="$vuetify?.display?.lgAndUp ? 'pl-3 pr-0 pt-3' : 'px-0 pt-3'"
                >
                  <LabelText
                    labelXl="4"
                    labelLg="6"
                    labelMd="3"
                    labelSm="4"
                    textXl="8"
                    textLg="6"
                    textMd="4"
                    textSm="5"
                    isRequired
                    :id="`drawingNumber_${item.drawingKey}`"
                    label="ED.10 Drawing Number"
                    :counter="10"
                    persistentCounter
                    :maxlength="10"
                    v-model="item.drawingNum"
                    :style="props.isEditable ? '' : 'padding-top: 2px'"
                    :isEditable="props.isEditable && !item.readOnly"
                    @update:modelValue="
                      {
                        changesDetectedDrawing = true;
                      }
                    "
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" class="px-0 pt-3">
                  <LabelText
                    labelXl="2"
                    labelLg="3"
                    labelMd="3"
                    labelSm="4"
                    textXl="10"
                    textLg="9"
                    textMd="9"
                    textSm="8"
                    type="textarea"
                    maxlength="255"
                    :id="`description_${item.drawingKey}`"
                    label="ED.11 Description"
                    v-model="item.drawingDesc"
                    :isEditable="props.isEditable && !item.readOnly"
                    @update:modelValue="
                      {
                        changesDetectedDrawing = true;
                      }
                    "
                  />
                </v-col>
              </v-row>
            </v-form>
          </td>
        </template>
        <template v-slot:bottom> </template>
      </v-data-table>
    </v-col>
  </v-row>
  <ConfirmDialog ref="closeConfirm" :cancelButtonText="BUTTONS.NO" />
</template>
<script setup>
import { computed, ref, watch, nextTick, onUnmounted } from "vue";
import { useInspectionStore } from "@/stores/inspection";
import { REFERENCE_TABLE } from "@/constants/ReferenceTables";
import { LOGGER } from "@/util/logger";
import { BUTTONS, COMMON_MESSAGE_CONSTANTS } from "@/constants/CommonWebConstants";
import DataTableHeader from "@/components/common/DataTableHeader.vue";
import { INSPECTION_MESSAGES, INSPECTION_DELETE_CONFIRM_MESSAGES, MODULE_TYPES } from "@/constants/InspectionConstants";
import { useSnackbarStore } from "@/stores/snackbar";
import ConfirmDialog from "@/components/common/ConfirmDialog.vue";
import IconTooltip from "@/components/common/IconTooltip.vue";
import LabelSelect from "@/components/common/LabelSelect.vue";
import LabelText from "@/components/common/LabelText.vue";
import { useConfigStore } from "@/stores/config";
import { useQuickSearchStore } from "@/stores/quickSearch";
import { useUserStore } from "@/stores/userStore";
import { useInventoryStore } from "@/stores/inventory";
import { clone } from "@/util/clone";
import { SNACKBAR_MESSAGE_TYPES } from "@/constants/GlobalSnackbar.js";

let localDrawingsArray = ref([]);

const emits = defineEmits(["updateDrawingsArray"]);

const props = defineProps({
  id: { default: "" },
  drawingsArray: { default: [] },
  moduleType: { default: MODULE_TYPES.INSPECTION },
  isEditable: { default: false, type: Boolean },
  addButtonText: { default: "Add" },
});

const configStore = useConfigStore();
const inspectionStore = useInspectionStore();
const quickSearchStore = useQuickSearchStore();
const userStore = useUserStore();
const inventoryStore = useInventoryStore();
const drawingTypes = computed(() => configStore.getReferenceValues(REFERENCE_TABLE.DRAWING_TYPE, null, null, true));

const activeBrkey = computed({
  get() {
    if (props.moduleType === MODULE_TYPES.INSPECTION) {
      return inspectionStore.selectedInspection.structureBridge.brkey;
    } else {
      return quickSearchStore.getStructure()?.BRKEY;
    }
  },
});

const setAddingOrEditing = (value) => {
  if (props.moduleType === MODULE_TYPES.INSPECTION) {
    inspectionStore.setAddingOrEditing(value);
  } else {
    inventoryStore.isAddingOrEditingDrawingTable = value;
  }
};

let validationSnackbar = computed({
  get() {
    if (props.moduleType === MODULE_TYPES.INSPECTION) {
      return inspectionStore.getShowValidationSnackbar;
    } else {
      return inventoryStore.showValidationSnackbar;
    }
  },
  set(value) {
    if (props.moduleType === MODULE_TYPES.INSPECTION) {
      inspectionStore.setShowValidationSnackbar(value);
    } else {
      inventoryStore.showValidationSnackbar = value;
    }
  },
});

let drawingsForm = ref(null);

let validDrawings = ref(false);

const closeConfirm = ref(null);

let snackBarId = ref("");
let changesDiscardedId = ref("");
const snackbarStore = useSnackbarStore();

onUnmounted(() => {
  snackbarStore.removeMessage(snackBarId.value);
});

const drawingsHeaders = ref([
  { title: "", key: "data-table-expand" },
  {
    line1: "ED.09",
    line2: "Drawing Type",
    line3: null,
    sortable: false,
    key: "drawingType",
  },
  {
    line1: "ED.10",
    line2: "Drawing Number",
    line3: null,
    sortable: false,
    key: "drawingNum",
  },
  {
    line1: "ED.11",
    line2: "Description",
    line3: null,
    sortable: false,
    key: "drawingDesc",
  },
  {
    line1: null,
    line2: "Action",
    line3: null,
    sortable: false,
    key: "Action",
  },
]);

let expandedRowsDrawings = ref([]);

let changesDetectedDrawing = ref(false);

const maxDrawingKey = computed(() => Math.max(0, ...localDrawingsArray.value.map((x) => x.drawingKey)));

const getNewDrawing = () => {
  return {
    brkey: activeBrkey.value,
    drawingKey: maxDrawingKey.value + 1,
    drawingType: "",
    drawingNum: "",
    updateDateTime: new Date().toISOString(),
    updateUserId: userStore.loggedInUser?.sub,
    drawingDesc: null,
  };
};

const getDrawings = () => {
  expandedRowsDrawings.value = [];
  localDrawingsArray.value = clone(props.drawingsArray);
  if (!localDrawingsArray.value?.[0]) {
    //remove null values from array(if any)
    localDrawingsArray.value = localDrawingsArray.value?.filter((a) => !!a);
  }
  for (const element of localDrawingsArray.value ?? []) {
    element.readOnly = true;
  }
};
getDrawings();

const rowClassDrawing = (data) => {
  return expandedRowsDrawings.value?.find((a) => a.drawingKey === data.drawingKey) ? "rowSelect" : "rowUnselect";
};

const closeDrawing = (detail) => {
  const updatedIndex = localDrawingsArray.value.findIndex((a) => a?.drawingKey === detail.drawingKey);
  if (props.isEditable && changesDetectedDrawing.value) {
    //show confirmation dialog on closing
    closeConfirm.value
      .open(INSPECTION_MESSAGES.DETECT_DATATABLE_CHANGE_CONFIRMATION_MESSAGE, BUTTONS.YES)
      .then((response) => {
        if (!response) {
          expandedRowsDrawings.value = [];
          changesDetectedDrawing.value = false;
          setAddingOrEditing(false);
          getDrawings();
          snackbarStore.removeMessage(snackBarId.value);
          changesDiscardedId.value = snackbarStore.showMessage({
            displayText: COMMON_MESSAGE_CONSTANTS.CHANGES_DISCARDED,
            messageType: SNACKBAR_MESSAGE_TYPES.SUCCESS,
            timeout: 10000,
          });
        }
      });
  } else {
    localDrawingsArray.value[updatedIndex].readOnly = true;
    expandedRowsDrawings.value = [];
    setAddingOrEditing(false);
    getDrawings();
    snackbarStore.removeMessage(snackBarId.value);
  }
};

const isExpandedDrawing = (details) => {
  return expandedRowsDrawings.value?.findIndex((a) => a.drawingKey == details.drawingKey) >= 0;
};

function editDrawing(detail) {
  setAddingOrEditing(true);
  snackBarId.value = snackbarStore.showMessage({
    displayText: INSPECTION_MESSAGES.DRAWINGS_DATATABLE,
  });
  detail.readOnly = false;
  expandedRowsDrawings.value = [detail];
  changesDetectedDrawing.value = false;
}

function deleteDrawing(detail) {
  closeConfirm.value
    .open(INSPECTION_DELETE_CONFIRM_MESSAGES.EDOCS_DRAWING_DELETE_CONFIRM_MESSAGE, BUTTONS.YES)
    .then((response) => {
      if (response) {
        const deleteIndex = localDrawingsArray.value.findIndex((a) => a?.drawingKey === detail.drawingKey);
        if (deleteIndex > -1) {
          localDrawingsArray.value.splice(deleteIndex, 1);
          if (props.moduleType === MODULE_TYPES.MANAGEMENT) {
            inventoryStore.setIsDirty(true);
          } else {
            inspectionStore.setDirtyFlag(true);
          }
          expandedRowsDrawings.value = [];
        }
        emits("updateDrawingsArray", localDrawingsArray.value);
      } else {
        expandedRowsDrawings.value = [];
      }
    });
}

const anyEditableDrawings = computed(() => {
  return expandedRowsDrawings.value?.find((element) => !element.readOnly);
});

const toggleDrawingRow = (detail) => {
  if (expandedRowsDrawings.value?.includes(detail)) {
    const index = expandedRowsDrawings.value.findIndex((a) => detail.drawingKey == a.drawingKey);
    expandedRowsDrawings.value.splice(index, 1);
  } else {
    expandedRowsDrawings.value.push(detail);
  }
};

function addDrawing() {
  setAddingOrEditing(true);
  snackBarId.value = snackbarStore.showMessage({
    displayText: INSPECTION_MESSAGES.DRAWINGS_DATATABLE,
  });
  let newDrawing = getNewDrawing();
  newDrawing.isAdd = true;
  newDrawing.readOnly = false;
  localDrawingsArray.value.unshift(newDrawing);
  expandedRowsDrawings.value = [newDrawing];
  changesDetectedDrawing.value = false;
  nextTick(() => {
    drawingsForm.value?.validate();
  });
}

function saveDrawing() {
  drawingsForm.value
    .validate()
    .then(() => {
      if (validDrawings.value) {
        emits("updateDrawingsArray", localDrawingsArray.value);
        //if all required fields entered - close the expanded row
        if (props.moduleType === MODULE_TYPES.MANAGEMENT) {
          inventoryStore.setIsDirty(true);
        } else {
          inspectionStore.setDirtyFlag(true);
        }
        expandedRowsDrawings.value = [];
        changesDetectedDrawing.value = false;
        setAddingOrEditing(false);
        validationSnackbar.value = false;
        snackbarStore.removeMessage(snackBarId.value);
      } else {
        validationSnackbar.value = true;
      }
    })
    .catch((err) => LOGGER.logException(err));
}

watch(
  () => props.drawingsArray,
  () => {
    expandedRowsDrawings.value = [];
  },
);

defineExpose({ getDrawings });
</script>
<style scoped lang="scss">
@use "@/styles/colors" as c;
.alignCenter {
  text-align: center;
}
.v-data-table :deep(button:hover) {
  background-color: inherit !important;
  color: inherit !important;
}

.v-data-table :deep(button:focus) {
  outline: none !important;
}
</style>
